import React from 'react';
import Lottie from 'lottie-react';
import starsAnimation from '../assets/lottie/bitcoin-access.json';

const Spinner = () => {
  return (
    <div className='fixed inset-0 z-[60] flex items-center justify-center bg-[#181818]'>
      <div className="w-[300px]">
        <Lottie
          animationData={starsAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
    </div>
  );
};

export default Spinner;
